import { Container, Box, Paper } from '@mui/material';
import { login } from '../services/auth.service';
import LoginForm from '../components/LoginForm';

export default function Login({ onLogin }) {
  const handleLogin = async (credentials) => {
    const { accessToken, refreshToken } = await login(credentials);

    onLogin({ accessToken, refreshToken });
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '80%',
      }}
    >
      <head>
        <title>Inicio de sesión</title>
      </head>

      <Box>
        <img src="/logo-2.png" alt="Compulab" style={{ maxHeight: 80 }} />
      </Box>

      <Paper elevation={6} sx={{ padding: 4, width: '100%' }}>
        <LoginForm onSubmit={handleLogin} />
      </Paper>

      <Box>
        <div style={{ height: 80 }} />
      </Box>
    </Container>
  );
}
